import { useState, useEffect } from 'react'
import { useLocation } from "react-router-dom";
import User from './EmployeeForm component/User';
import Document from './EmployeeForm component/Document';
import EmployeeInfo from './EmployeeForm component/EmployeeInfo';
import { fetchUserByIdApi } from '../../../Api/user';

interface Props {
  url: string;
  editEmployeeId: string | null;
  onClose: () => void;
};
type UserType = {
  id: string;
  name: string;
  email: string;
  mobile: string;
  gender: number | null;
  address: string;
  roleType: string;
};

interface EmployeeInterface {
  id: string; // UNIQUEIDENTIFIER
  userId: string; // FK to User table
  employeeType: string; // NVARCHAR(50)
  permanentAddress: string; // NVARCHAR(MAX)
  isActive: boolean; // BIT
  salary: number; // INT
  hourlyRate: number; // INT
  joiningDate: string; // DATE in 'YYYY-MM-DD' format
  leavingDate?: string | null; // DATE, nullable
  updatedBy: string; // UNIQUEIDENTIFIER
  updatedOn: string; // DATETIME in ISO format
}

const EmployeeForm = ({ url, onClose, editEmployeeId }: Props) => {
  const location = useLocation();
  const id = editEmployeeId;

  const [selectedUser, setSelectedUser] = useState<UserType>();
  const [Employee, setEmployee] = useState<EmployeeInterface | null>(null);
  const [searchUserName, setSearchUserName] = useState<string>("");
  async function handleApiClick() {
    try {
      if (id) {
        const userData: any = await fetchUserByIdApi(url, id);
        setSearchUserName(userData.name);
        setSelectedUser(userData);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }
  useEffect(() => {
    handleApiClick();
  }, [id])

  return (
    <div className="max-w-6xl p-6">
      <h2 className="text-3xl font-bold text-blue-600 mb-5">
        Employee Form
      </h2>

      {/* User */}
      <div className="flex flex-col gap-4 mb-4">
        <User url={url} selectedUser={selectedUser} setSelectedUser={setSelectedUser} searchUserName={searchUserName} setSearchUserName={setSearchUserName} permanentAddress={Employee?.permanentAddress} setEmployee={setEmployee} />
      </div>

      {selectedUser && (
        <div>
          {/* Employee */}
          <div className="flex flex-col gap-4 mb-4">
            <EmployeeInfo url={url} Employee={Employee} setEmployee={setEmployee} selectedUser={selectedUser} />
          </div>

          {/* Document */}

          <div className="flex flex-col  gap-4 mb-4">
            <Document
              url={url}
              user={selectedUser}
            />
          </div>

        </div>
      )}
    </div>


  )
}

export default EmployeeForm